import React, { useRef } from 'react';

export interface T05SpotlightBorderProps {
  children: React.ReactNode;
  className?: string;
  size?: number;
  intensity?: number;
}

export const T05SpotlightBorder: React.FC<T05SpotlightBorderProps> = ({
  children,
  className = '',
  size = 460,
  intensity = 0.42,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const onPointerMove = (e: React.PointerEvent<HTMLDivElement>) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty('--spot-x', `${e.clientX - rect.left}px`);
    el.style.setProperty('--spot-y', `${e.clientY - rect.top}px`);
  };

  const onPointerLeave = () => {
    const el = ref.current;
    if (!el) return;
    el.style.setProperty('--spot-x', '-9999px');
    el.style.setProperty('--spot-y', '-9999px');
  };

  return (
    <div
      ref={ref}
      className={`t05-spotlight-border${className ? ` ${className}` : ''}`}
      style={
        {
          '--spot-size': `${size}px`,
          '--spot-intensity': String(intensity),
        } as React.CSSProperties
      }
      onPointerMove={onPointerMove}
      onPointerLeave={onPointerLeave}
    >
      <div className="t05-spotlight-border__ring" aria-hidden />
      <div className="t05-spotlight-border__ring t05-spotlight-border__ring--hover" aria-hidden />
      <div className="t05-spotlight-border__inner">{children}</div>
    </div>
  );
};
